import React from 'react'
import { array } from 'prop-types'
import styled from 'styled-components'
import { SubmitButton, RemoveButton } from './index'
import Close from './IconClose'
import PaperclipHorizontal from '../../../vectors/IconPaperclipHorizontal'
import { Box } from 'rebass'

const FileNameWrapper = styled(Box)`
  display: flex;
  line-height: 20px;
`
const FileName = styled.div`
  color: ${(props) => props.theme.colors.blue};
  flex: 1 0 auto;
  word-break: break-all;
  margin-left: 8px;
`

class FileFormInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      files: []
    }
    this.fileInput = React.createRef()
    this.triggerInputFile = this.triggerInputFile.bind(this)
    this.handleFileChange = this.handleFileChange.bind(this)
    this.handleFileClear = this.handleFileClear.bind(this)
    this.onChange = this.props.onChange
  }

  triggerInputFile() {
    this.fileInput.click()
  }

  handleFileClear(index) {
    this.fileInput.value = ''
    const files = this.state.files
    files.splice(index, 1)

    this.setState({ files })
    this.onChange('files', files)
  }

  handleFileChange(e) {
    const files = this.state.files
    files.push(...e.target.files)
    if (!files.length) return

    this.onChange('files', files)
    this.setState({ files })
  }

  render() {
    return (
      <div>
        <input
          ref={(fileInput) => (this.fileInput = fileInput)}
          type="file"
          aria-label="Add files"
          placeholder="Add Files"
          style={{ display: 'none' }}
          name="files"
          onChange={(e) => {
            this.handleFileChange(e)
          }}
          multiple
        />
        <SubmitButton aria-label="attach file" onClick={this.triggerInputFile}>
          Add Files
        </SubmitButton>
        {this.state.files.length > 0 &&
          this.state.files.map((file, index) => (
            <FileNameWrapper key={index} mt={3}>
              <div>
                <PaperclipHorizontal />{' '}
              </div>
              <div>
                <FileName>{file.name}</FileName>
              </div>
              <div>
                <RemoveButton
                  type="button"
                  onClick={() => this.handleFileClear(index)}
                >
                  <Close alt="close" />
                </RemoveButton>
              </div>
            </FileNameWrapper>
          ))}
      </div>
    )
  }
}

FileFormInput.defaultProps = {
  details: []
}
FileFormInput.propTypes = {
  details: array
}

export default FileFormInput
